import { onCleanup, onMount } from "solid-js";

/**
 * Closing a transient layer the way a reader expects: a click anywhere outside
 * it, or Escape.
 *
 * Both listeners sit on the document because the events that must close the
 * layer are, by definition, ones the layer itself never sees. The caller passes
 * the element that counts as "inside"; a click on the trigger reaches it too,
 * so the trigger's own toggle still works.
 */
export const useDismiss = (inside: () => Node, close: () => void) => {
  onMount(() => {
    const away = (event: MouseEvent) => {
      if (!inside().contains(event.target as Node)) close();
    };
    const escape = (event: KeyboardEvent) => {
      if (event.key === "Escape") close();
    };

    document.addEventListener("mousedown", away);
    document.addEventListener("keydown", escape);
    onCleanup(() => {
      document.removeEventListener("mousedown", away);
      document.removeEventListener("keydown", escape);
    });
  });
};
